
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/corporatiu/atencio/mapaweb",
      function () {
        return require("private-next-pages/corporatiu/atencio/mapaweb/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/corporatiu/atencio/mapaweb"])
      });
    }
  